import { useState } from 'react'

export type LinkedRecordsExpansion<TPanel extends string> = {
    expandedRow: { id: string; panel: TPanel } | null
    toggleExpandedRow: (rowId: string, panel: TPanel) => void
    recordsLabelByPanel: Record<TPanel, string>
}

export const useLinkedRecordsExpansion = <TPanel extends string>(
    recordsLabelByPanel: Record<TPanel, string>
): LinkedRecordsExpansion<TPanel> => {
    const [expandedRow, setExpandedRow] = useState<LinkedRecordsExpansion<TPanel>['expandedRow']>(null)

    const toggleExpandedRow = (rowId: string, panel: TPanel) => {
        setExpandedRow((currentRow) =>
            currentRow?.id === rowId && currentRow.panel === panel ? null : { id: rowId, panel }
        )
    }

    return { expandedRow, toggleExpandedRow, recordsLabelByPanel }
}
